import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { ApiError } from 'src/api/instance';

type ThunkArgs = { rejectValue: ApiError };

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createAsyncThunkFromFetch = <R, Params>(prefix: string, req: (state: Params) => Promise<AxiosResponse<R>>) =>
  createAsyncThunk<R, Params, ThunkArgs>(prefix, async (state, thunkAPI) => {
    try {
      const response = await req(state);

      if (response?.status >= 400 || !response) {
        return thunkAPI.rejectWithValue(<ApiError>response?.data);
      }

      return response.data;
    } catch (e) {
      console.error(e);
      return {} as Record<string, unknown> as never;
    }
  });

export default createAsyncThunkFromFetch;
